<style scoped></style>

<template>
  <section class="container" >
    <div class="columns">
      <div class="column">
        <!--<portal-perfil/>-->
      </div>

      <div class="column is-4 has-text-centered">
        <img src="../../assets/images/logo_piller.png" v-if="$sistema.nome() === 'PILLER'"/>
      </div>

    </div>
    <div class="columns">
      <div class="column">

        <code>{{admim}}</code>

      </div>
    </div>

  </section>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        meta: {}
      }
    },
    methods: {
      mensagemFalha (res) {
        this.toast(res)
        this.loadingForm = false
      },
      toast (res) {
        let msg = res.body.message ? res.body.message : res.body
        let tipo = 'is-danger'
        switch (res.status) {
          case 401:
            tipo = 'is-danger'
            msg = 'Token inválido! Favor logar novamente.'
            break
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
          case 500:
            tipo = 'is-danger'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 4 * 1000
        })
      }
    },
    computed: {
      admim () {
        return this.$store.state.admin
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/Dashboard.vue